// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_minimal__gUGsl {
  box-sizing: border-box;
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
}
.Button_minimal__gUGsl.Button_color-primary__IcvAq {
  color: var(--primary-color);
}
.Button_minimal__gUGsl.Button_color-primary__IcvAq:hover {
  background: var(--background-color);
}
.Button_minimal__gUGsl.Button_color-primary__IcvAq:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_minimal__gUGsl.Button_color-font-primary__H28Ee {
  color: var(--font-primary-color);
}
.Button_minimal__gUGsl.Button_color-font-primary__H28Ee:hover {
  background: var(--background-color);
}
.Button_minimal__gUGsl.Button_color-font-primary__H28Ee:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_minimal__gUGsl.Button_color-secondary__SRq7F {
  color: var(--secondary-color);
}
.Button_minimal__gUGsl.Button_color-secondary__SRq7F:hover {
  background: var(--background-color);
}
.Button_minimal__gUGsl.Button_color-secondary__SRq7F:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_minimal__gUGsl.Button_color-accent__ayw3H {
  color: var(--accent-color);
}
.Button_minimal__gUGsl.Button_color-accent__ayw3H:hover {
  background: var(--background-color);
}
.Button_minimal__gUGsl.Button_color-accent__ayw3H:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_minimal__gUGsl.Button_color-warning__ueXj5 {
  color: orange;
}
.Button_minimal__gUGsl.Button_color-warning__ueXj5:hover {
  background: var(--background-color);
}
.Button_minimal__gUGsl.Button_color-warning__ueXj5:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_minimal__gUGsl.Button_color-error__tGcK2 {
  color: #df6767;
}
.Button_minimal__gUGsl.Button_color-error__tGcK2:hover {
  background: var(--background-color);
}
.Button_minimal__gUGsl.Button_color-error__tGcK2:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_minimal__gUGsl.Button_color-white__gmjGo {
  color: #fff;
}
.Button_minimal__gUGsl.Button_color-white__gmjGo:hover {
  background: transparent;
}
.Button_minimal__gUGsl.Button_color-white__gmjGo:active {
  background-color: transparent;
  background-size: 100%;
  transition: background 0s;
}
.Button_minimal__gUGsl :hover {
  text-decoration: underline;
}

.Button_pointer__mF58o {
  cursor: pointer;
}

.Button_button__hWZrs {
  box-sizing: border-box;
  border: none;
  background-color: transparent;
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 3px;
  transition: background 0.3s;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.Button_button__hWZrs.Button_full-width__I13E2 {
  width: 100%;
}
.Button_button__hWZrs:hover {
  cursor: pointer;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-primary__IcvAq {
  color: var(--primary-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-primary__IcvAq:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-primary__IcvAq:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-font-primary__H28Ee {
  color: var(--font-primary-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-font-primary__H28Ee:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-font-primary__H28Ee:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-secondary__SRq7F {
  color: var(--secondary-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-secondary__SRq7F:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-secondary__SRq7F:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-accent__ayw3H {
  color: var(--accent-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-accent__ayw3H:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-accent__ayw3H:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-warning__ueXj5 {
  color: orange;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-warning__ueXj5:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-warning__ueXj5:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-error__tGcK2 {
  color: #df6767;
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-error__tGcK2:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-normal__QWmvG.Button_color-error__tGcK2:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-primary__IcvAq {
  background-color: var(--primary-color);
  color: #fff;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-primary__IcvAq:hover {
  background: var(--primary-color);
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-primary__IcvAq:active {
  background-color: var(--primary-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-secondary__SRq7F {
  background-color: var(--secondary-color);
  color: #fff;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-secondary__SRq7F:hover {
  background: var(--secondary-color);
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-secondary__SRq7F:active {
  background-color: var(--secondary-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-accent__ayw3H {
  background-color: var(--accent-color);
  color: #fff;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-accent__ayw3H:hover {
  background: var(--accent-color);
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-accent__ayw3H:active {
  background-color: var(--accent-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-warning__ueXj5 {
  background-color: orange;
  color: #fff;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-warning__ueXj5:hover {
  background: orange;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-warning__ueXj5:active {
  background-color: orange;
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-error__tGcK2 {
  background-color: #df6767;
  color: #fff;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-error__tGcK2:hover {
  background: #df6767;
}
.Button_button__hWZrs.Button_variant-flat__QmXeO.Button_color-error__tGcK2:active {
  background-color: #df6767;
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.1411764706), 0 1px 5px rgba(0, 0, 0, 0.1215686275);
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-primary__IcvAq {
  background-color: var(--primary-color);
  color: #fff;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-primary__IcvAq:hover {
  background: var(--primary-color);
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-primary__IcvAq:active {
  background-color: var(--primary-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-secondary__SRq7F {
  background-color: var(--secondary-color);
  color: #fff;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-secondary__SRq7F:hover {
  background: var(--secondary-color);
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-secondary__SRq7F:active {
  background-color: var(--secondary-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-accent__ayw3H {
  background-color: var(--accent-color);
  color: #fff;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-accent__ayw3H:hover {
  background: var(--accent-color);
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-accent__ayw3H:active {
  background-color: var(--accent-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-warning__ueXj5 {
  background-color: orange;
  color: #fff;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-warning__ueXj5:hover {
  background: orange;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-warning__ueXj5:active {
  background-color: orange;
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-error__tGcK2 {
  background-color: #df6767;
  color: #fff;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-error__tGcK2:hover {
  background: #df6767;
}
.Button_button__hWZrs.Button_variant-raised__GwJOK.Button_color-error__tGcK2:active {
  background-color: #df6767;
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV {
  border-style: solid;
  border-width: 1px;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-primary__IcvAq {
  border-color: var(--primary-color);
  color: var(--primary-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-primary__IcvAq:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-primary__IcvAq:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-secondary__SRq7F {
  border-color: var(--secondary-color);
  color: var(--secondary-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-secondary__SRq7F:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-secondary__SRq7F:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-accent__ayw3H {
  border-color: var(--accent-color);
  color: var(--accent-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-accent__ayw3H:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-accent__ayw3H:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-warning__ueXj5 {
  border-color: orange;
  color: orange;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-warning__ueXj5:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-warning__ueXj5:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-error__tGcK2 {
  border-color: #df6767;
  color: #df6767;
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-error__tGcK2:hover {
  background: var(--background-color);
}
.Button_button__hWZrs.Button_variant-outline__fEcNV.Button_color-error__tGcK2:active {
  background-color: var(--background-color);
  background-size: 100%;
  transition: background 0s;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Button/Button.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAsBA;EACE,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AArBF;AAuBE;EApBA,2BCTQ;ADSV;AAEE;EACE,mCCYM;ADZV;AAGE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AADJ;AAgBE;EAxBA,gCCNa;ADiBf;AATE;EACE,mCCYM;ADDV;AARE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAUJ;AAaE;EAhCA,6BCRU;AD8BZ;AApBE;EACE,mCCYM;ADUV;AAnBE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAqBJ;AAME;EApCA,0BCPO;ADwCT;AA/BE;EACE,mCCYM;ADqBV;AA9BE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAgCJ;AADE;EAxCA,aCGQ;ADyCV;AA1CE;EACE,mCCYM;ADgCV;AAzCE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AA2CJ;AARE;EA5CA,cCIM;ADmDR;AArDE;EACE,mCCYM;AD2CV;AApDE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAsDJ;AAfE;EAhDA,WCKM;AD6DR;AAhEE;EACE,uBA8C8B;AAoBlC;AA/DE;EACE,6BA0C8B;EAzC9B,qBAAA;EACA,yBAAA;AAiEJ;AAtBE;EACE,0BAAA;AAwBJ;;AApBA;EACE,eAAA;AAuBF;;AApBA;EACE,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,aErEU;EFsEV,kBErEU;EFsEV,mBEtEU;EFuEV,kBE3Ec;EF4Ed,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAuBF;AArBE;EACE,WAAA;AAuBJ;AApBE;EACE,eAAA;AAsBJ;AAlBI;EArFF,2BCTQ;ADmHV;AAxGE;EACE,mCCYM;AD8FV;AAvGE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAyGJ;AAzBI;EAzFF,gCCNa;AD2Hf;AAnHE;EACE,mCCYM;ADyGV;AAlHE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAoHJ;AA5BI;EAjGF,6BCRU;ADwIZ;AA9HE;EACE,mCCYM;ADoHV;AA7HE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AA+HJ;AAnCI;EArGF,0BCPO;ADkJT;AAzIE;EACE,mCCYM;AD+HV;AAxIE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AA0IJ;AA1CI;EAzGF,aCGQ;ADmJV;AApJE;EACE,mCCYM;AD0IV;AAnJE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAqJJ;AAjDI;EA7GF,cCIM;AD6JR;AA/JE;EACE,mCCYM;ADqJV;AA9JE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAgKJ;AAtDI;EACE,sCC7HI;EDSR,WCQmB;ADqKrB;AA3KE;EACE,gCCZM;ADyLV;AA1KE;EACE,sCChBM;EDiBN,qBAAA;EACA,yBAAA;AA4KJ;AA5DI;EACE,wCClIM;EDQV,WCSqB;ADgLvB;AAvLE;EACE,kCCXQ;ADoMZ;AAtLE;EACE,wCCfQ;EDgBR,qBAAA;EACA,yBAAA;AAwLJ;AA/DI;EACE,qCC1IG;EDOP,WCUkB;AD2LpB;AAnME;EACE,+BCVK;AD+MT;AAlME;EACE,qCCdK;EDeL,qBAAA;EACA,yBAAA;AAoMJ;AArEI;EACE,wBCtII;EDHR,WCWmB;ADsMrB;AA/ME;EACE,kBAAA;AAiNJ;AA9ME;EACE,wBCJM;EDKN,qBAAA;EACA,yBAAA;AAgNJ;AA3EI;EACE,yBC3IE;EDJN,WCYiB;ADiNnB;AA3NE;EACE,mBCCI;AD4NR;AA1NE;EACE,yBCHI;EDIJ,qBAAA;EACA,yBAAA;AA4NJ;AAhFE;EACE,2HAAA;AAkFJ;AAhFI;EACE,sCClKI;EDSR,WCQmB;ADoOrB;AA1OE;EACE,gCCZM;ADwPV;AAzOE;EACE,sCChBM;EDiBN,qBAAA;EACA,yBAAA;AA2OJ;AAtFI;EACE,wCCvKM;EDQV,WCSqB;AD+OvB;AAtPE;EACE,kCCXQ;ADmQZ;AArPE;EACE,wCCfQ;EDgBR,qBAAA;EACA,yBAAA;AAuPJ;AAzFI;EACE,qCC/KG;EDOP,WCUkB;AD0PpB;AAlQE;EACE,+BCVK;AD8QT;AAjQE;EACE,qCCdK;EDeL,qBAAA;EACA,yBAAA;AAmQJ;AA/FI;EACE,wBC3KI;EDHR,WCWmB;ADqQrB;AA9QE;EACE,kBAAA;AAgRJ;AA7QE;EACE,wBCJM;EDKN,qBAAA;EACA,yBAAA;AA+QJ;AArGI;EACE,yBChLE;EDJN,WCYiB;ADgRnB;AA1RE;EACE,mBCCI;AD2RR;AAzRE;EACE,yBCHI;EDIJ,qBAAA;EACA,yBAAA;AA2RJ;AA1GE;EACE,mBAAA;EACA,iBAAA;AA4GJ;AA1GI;EACE,kCCxMI;EDSR,2BCTQ;ADqTV;AA1SE;EACE,mCCYM;ADgSV;AAzSE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AA2SJ;AAhHI;EACE,oCC7MM;EDQV,6BCRU;ADgUZ;AAtTE;EACE,mCCYM;AD4SV;AArTE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAuTJ;AAtHI;EACE,iCClNG;EDOP,0BCPO;AD2UT;AAlUE;EACE,mCCYM;ADwTV;AAjUE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AAmUJ;AA5HI;EACE,oBC9MI;EDHR,aCGQ;AD6UV;AA9UE;EACE,mCCYM;ADoUV;AA7UE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AA+UJ;AAlII;EACE,qBCnNE;EDJN,cCIM;ADwVR;AA1VE;EACE,mCCYM;ADgVV;AAzVE;EACE,yCCQM;EDPN,qBAAA;EACA,yBAAA;AA2VJ","sourcesContent":["@use 'sass:color';\n@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n@mixin button-color(\n  $color: $primary,\n  $fontColor: $primary-font-color,\n  $lightness: 10%\n) {\n  color: $fontColor;\n\n  &:hover {\n    background: $color;\n  }\n\n  &:active {\n    background-color: $color;\n    background-size: 100%;\n    transition: background 0s;\n  }\n}\n\n.minimal {\n  box-sizing: border-box;\n  border: none;\n  background-color: transparent;\n  padding: 0;\n  margin: 0;\n\n  &.color-primary {\n    @include button-color($color: $bg-main, $fontColor: $primary);\n  }\n\n  &.color-font-primary {\n    @include button-color(\n      $color: $bg-main,\n      $fontColor: $font-primary,\n      $lightness: 0%\n    );\n  }\n\n  &.color-secondary {\n    @include button-color($color: $bg-main, $fontColor: $secondary);\n  }\n\n  &.color-accent {\n    @include button-color($color: $bg-main, $fontColor: $accent);\n  }\n\n  &.color-warning {\n    @include button-color($color: $bg-main, $fontColor: $warning);\n  }\n\n  &.color-error {\n    @include button-color($color: $bg-main, $fontColor: $error);\n  }\n\n  &.color-white {\n    @include button-color($color: transparent, $fontColor: $white);\n  }\n\n  & :hover {\n    text-decoration: underline;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.button {\n  box-sizing: border-box;\n  border: none;\n  background-color: transparent;\n  padding: $padding-m;\n  padding-left: $padding-l;\n  padding-right: $padding-l;\n  border-radius: $border-radius;\n  transition: background 0.3s;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  &.full-width {\n    width: 100%;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &.variant-normal {\n    &.color-primary {\n      @include button-color($color: $bg-main, $fontColor: $primary);\n    }\n\n    &.color-font-primary {\n      @include button-color(\n        $color: $bg-main,\n        $fontColor: $font-primary,\n        $lightness: 0%\n      );\n    }\n\n    &.color-secondary {\n      @include button-color($color: $bg-main, $fontColor: $secondary);\n    }\n\n    &.color-accent {\n      @include button-color($color: $bg-main, $fontColor: $accent);\n    }\n\n    &.color-warning {\n      @include button-color($color: $bg-main, $fontColor: $warning);\n    }\n\n    &.color-error {\n      @include button-color($color: $bg-main, $fontColor: $error);\n    }\n  }\n\n  &.variant-flat {\n    &.color-primary {\n      background-color: $primary;\n\n      @include button-color($color: $primary, $fontColor: $primary-font-color);\n    }\n\n    &.color-secondary {\n      background-color: $secondary;\n\n      @include button-color(\n        $color: $secondary,\n        $fontColor: $secondary-font-color\n      );\n    }\n\n    &.color-accent {\n      background-color: $accent;\n\n      @include button-color($color: $accent, $fontColor: $accent-font-color);\n    }\n\n    &.color-warning {\n      background-color: $warning;\n\n      @include button-color($color: $warning, $fontColor: $warning-font-color);\n    }\n\n    &.color-error {\n      background-color: $error;\n\n      @include button-color($color: $error, $fontColor: $error-font-color);\n    }\n  }\n\n  &.variant-raised {\n    box-shadow: 0 3px 1px -2px #0003, 0 2px 2px #00000024, 0 1px 5px #0000001f;\n\n    &.color-primary {\n      background-color: $primary;\n\n      @include button-color($color: $primary, $fontColor: $primary-font-color);\n    }\n\n    &.color-secondary {\n      background-color: $secondary;\n\n      @include button-color(\n        $color: $secondary,\n        $fontColor: $secondary-font-color\n      );\n    }\n\n    &.color-accent {\n      background-color: $accent;\n\n      @include button-color($color: $accent, $fontColor: $accent-font-color);\n    }\n\n    &.color-warning {\n      background-color: $warning;\n\n      @include button-color($color: $warning, $fontColor: $warning-font-color);\n    }\n\n    &.color-error {\n      background-color: $error;\n\n      @include button-color($color: $error, $fontColor: $error-font-color);\n    }\n  }\n\n  &.variant-outline {\n    border-style: solid;\n    border-width: 1px;\n\n    &.color-primary {\n      border-color: $primary;\n\n      @include button-color($color: $bg-main, $fontColor: $primary);\n    }\n\n    &.color-secondary {\n      border-color: $secondary;\n\n      @include button-color($color: $bg-main, $fontColor: $secondary);\n    }\n\n    &.color-accent {\n      border-color: $accent;\n\n      @include button-color($color: $bg-main, $fontColor: $accent);\n    }\n\n    &.color-warning {\n      border-color: $warning;\n\n      @include button-color($color: $bg-main, $fontColor: $warning);\n    }\n\n    &.color-error {\n      border-color: $error;\n\n      @include button-color($color: $bg-main, $fontColor: $error);\n    }\n  }\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"minimal": `Button_minimal__gUGsl`,
	"color-primary": `Button_color-primary__IcvAq`,
	"color-font-primary": `Button_color-font-primary__H28Ee`,
	"color-secondary": `Button_color-secondary__SRq7F`,
	"color-accent": `Button_color-accent__ayw3H`,
	"color-warning": `Button_color-warning__ueXj5`,
	"color-error": `Button_color-error__tGcK2`,
	"color-white": `Button_color-white__gmjGo`,
	"pointer": `Button_pointer__mF58o`,
	"button": `Button_button__hWZrs`,
	"full-width": `Button_full-width__I13E2`,
	"variant-normal": `Button_variant-normal__QWmvG`,
	"variant-flat": `Button_variant-flat__QmXeO`,
	"variant-raised": `Button_variant-raised__GwJOK`,
	"variant-outline": `Button_variant-outline__fEcNV`
};
export default ___CSS_LOADER_EXPORT___;
